import { getFetch } from '../fetch';
import { apiConfig } from '../config';

import { SubjectSlugs, SubjectGrades } from '../../../typings';

export interface GetSubjectGradesQueryParams {
    subjects?: SubjectSlugs[];
    isAvailableToTeacher?: boolean;
    autoassigned?: boolean;
}

export function getSubjectGrades({
    autoassigned = false,
    isAvailableToTeacher = true,
    subjects,
}: GetSubjectGradesQueryParams): Promise<SubjectGrades> {
    const { apiGetSubjectGrades } = apiConfig.getStaticUrls();
    const subjectsParam = subjects ? subjects.join(',') : undefined;

    return getFetch(apiGetSubjectGrades, {
        autoassigned: autoassigned,
        is_available_for_teacher: isAvailableToTeacher,
        subjects: subjectsParam,
    });
}
